<template>
  <div class="Login">
    <PageHeader></PageHeader>

    <div class="loginMain">
      <img class="bg" :src="GetResourceUrl('login.jpg')" />
      <div class="slogan">
        <div class="mainTitle">{{ l("买锻材就上中锻材") }}</div>
        <div class="subTitle">{{ l("真材实料，品质保障") }}</div>
      </div>
      <div class="formContainer">
        <div class="formTitleContainer">
          <div
            v-if="status == 'login' || status == 'login_tel'"
            key="login"
            class="title"
          >
            <div
              :class="{ unSelected: status == 'login_tel' }"
              @click="$router.push({ path: 'login' })"
            >
              {{ l("密码登录") }}
            </div>
            <div
              style="margin-left: 25px"
              :class="{ unSelected: status == 'login' }"
              @click="$router.push({ path: 'login_tel' })"
            >
              {{ l("验证码登录") }}
            </div>
          </div>

          <div v-if="status == 'register'" class="title">
            {{ l("新人注册") }}
          </div>
          <div v-if="status == 'forget_password'" class="title">
            {{ l("忘记密码") }}
          </div>
        </div>

        <el-form :model="form" ref="form" :rules="formRules">




          <el-form-item prop="account">
            <el-input
              v-model.trim="form.account"
              :placeholder="l('请输入') + l('手机号或邮箱')"
            ></el-input>
          </el-form-item>
          
          <el-form-item
            v-if="status == 'login' || status == 'register'"
            prop="password"
            key="password"
          >
            <el-input
              v-model="form.password"
              :placeholder="l('请输入') + l('密码')"
              show-password
              @keyup.native.enter="doLogin"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-else-if="status == 'forget_password'"
            prop="password"
            key="new_password"
          >
            <el-input
              v-model="form.password"
              :placeholder="l('请输入') + l('新密码')"
              show-password
            ></el-input>
          </el-form-item>

          <div
            v-if="
              status == 'login_tel' ||
              status == 'register' ||
              status == 'forget_password'
            "
            key="verifyCode"
          >
            <el-form-item>
              <el-input
                v-model.trim="verifyCode"
                :placeholder="l('请输入') + l('图形验证码')"
              >
                <div slot="suffix" style="height: 0">
                  <img
                    @click="getVerifyImage"
                    v-if="verifyImage"
                    style="width: 120px"
                    :src="verifyImage"
                  />
                </div>
              </el-input>
            </el-form-item>
            <el-form-item prop="verify_code">
              <el-input
                v-model.trim="form.verify_code"
                ref="verify_code"
                :placeholder="l('请输入') + l('验证码')"
                @keyup.native.enter="checkVerifyCodeEnter"
              >
                <div slot="suffix">
                  <el-button
                    style="width: 120px"
                    plain
                    @click="getVerifyCode"
                    :disabled="countDown > 0"
                  >
                    <template v-if="countDown == 0">
                      {{ l("获取验证码") }}
                    </template>
                    <template v-else>
                      {{ l("已发送") }}({{ countDown }})
                    </template>
                  </el-button>
                </div>
              </el-input>
            </el-form-item>
          </div>


          <el-form-item prop="country" v-if="status == 'register'" key="country">
            <el-select v-model="form.country" placeholder="请选择" filterable>
              <el-option
                v-for="item in $store.state.basicInfo.countryList"
                :key="item.code"
                :label="item.cnName+' ('+item.name+')'"
                :value="item.code">
                <span style="float: left">{{item.cnName}}（{{ item.name }}）</span>
                <span style="float: right">
                  <img :src="GetResourceUrl('flags/' + item.code.toLowerCase() + '.png')" style="width:30px;"/>
                </span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>

        <el-button
          v-if="status == 'login' || status == 'login_tel'"
          class="submit_btn"
          type="warning"
          @click="doLogin"
          >{{ l("登 录") }}</el-button
        >
        <el-button
          v-if="status == 'register'"
          class="submit_btn"
          type="warning"
          @click="doRegister"
          >{{ l("注 册") }}</el-button
        >
        <el-button
          v-if="status == 'forget_password'"
          class="submit_btn"
          type="warning"
          @click="forgetPassword"
          >{{ l("重置密码") }}</el-button
        >

        <div class="ul">
          <div
            v-if="status == 'login' || status == 'login_tel'"
            @click="$router.push({ path: 'forget_password' })"
          >
            {{ l("忘记密码") }}
          </div>
          <div
            v-if="status == 'register' || status == 'forget_password'"
            @click="$router.push({ path: 'login' })"
          >
            {{ l("账号密码登录") }}
          </div>
          <div
            v-if="status == 'login' || status == 'login_tel'"
            @click="$router.push({ path: 'register' })"
          >
            {{ l("立即注册") }}
          </div>
        </div>

        <div class="tip">
          {{ l("登录即表明您已同意") }}
          <span @click="goArticleByKey('用户协议')"
            >《{{ l("用户协议") }}》</span
          >{{ l("和")
          }}<span @click="goArticleByKey('隐私政策')"
            >《{{ l("隐私政策") }}》</span
          >
        </div>
      </div>
    </div>

    <PreLoginInfo ref="PreLoginInfo" @submitDialog="afterLogin" />
  </div>
</template>

<script>
import PageHeader from "@/components/layout/PageHeader";
import PreLoginInfo from "@/views/account/PreLoginInfo.vue";

export default {
  name: "Login",
  components: {
    PageHeader,
    PreLoginInfo,
  },
  data() {
    return {
      cities: [{
          value: 'Beijing',
          label: '北京'
        }, {
          value: 'Shanghai',
          label: '上海'
        }, {
          value: 'Nanjing',
          label: '南京'
        }, {
          value: 'Chengdu',
          label: '成都'
        }, {
          value: 'Shenzhen',
          label: '深圳'
        }, {
          value: 'Guangzhou',
          label: '广州'
        }],

      status: "", //login login_tel register forget_password
      form: {
        account: "",
        password: "",
        verify_code: "",
        country: "CN"
      },
      //图形验证码相关
      verifyCode: "",
      verifyImage: "",
      verifyKey: "",
      //短信验证码倒计时
      countDown: 0,
      countDownTimer: null,

      formRules: {
        account: [
          {
            required: true,
            message: this.l("请输入") + this.l("手机号或邮箱"),
            trigger: "change",
          },
        ],
        password: [
          {
            required: true,
            message: this.l("请输入") + this.l("密码"),
            trigger: "change",
          },
          {
            validator: (rule, value, callback) => {
              if (!/^(\w){6,12}$/.test(value)) {
                callback(new Error(this.l("请输入6-12位的英文/数字密码")));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        verify_code: [
          {
            required: true,
            message: this.l("请输入") + this.l("验证码"),
            trigger: "change",
          },
        ],
      },
    };
  },
  created() {
    this.status = this.$route.name;
    if (
      this.status == "login_tel" ||
      this.status == "register" ||
      this.status == "forget_password"
    ) {
      this.getVerifyImage();
    }
  },
  mounted() {},
  destroyed() {
    clearTimeout(this.countDownTimer);
  },
  methods: {
    doLogin() {
      this.$refs["form"].validate((valid, obj) => {
        if (!valid) {
          return this.$message.error(obj[Object.keys(obj)[0]][0].message);
        }
        this.axios
          .post("/api/account/login/", {
            account: this.form.account,
            login_type: this.status == "login" ? 1 : 2,
            password: this.form.password,
            verify_code: this.form.verify_code,
            source: "pc",
          })
          .then((response) => {
            this.$localStorage.remove("host_token");
            this.$localStorage.remove("host_token_admin");
            
            this.$store.setSession("host_token", null);
            this.$store.setSession("host_token_admin", null);

            this.$store.setSession("token", response);

            setTimeout(() => {
              //保证在finally之后执行
              this.$store.dispatch("updateSession").then(() => {
                //预填信息已完整
                if (
                  this.$store.state.session.user.pre_company_name &&
                  this.$store.state.session.user.pre_business_tag_id
                ) {
                  this.afterLogin();
                } else {
                  this.$refs.PreLoginInfo.Show();
                }
              });
            });
          });
      });
    },
    afterLogin() {
      this.$localStorage.set("token", this.$store.state.session.token); //等确认登录成功再缓存本地，防止未填写就刷新页面
      this.$store.commit("updateUnreadNotify");
      this.$router.push({ path: "/" });
    },
    doRegister() {
      this.$refs["form"].validate((valid, obj) => {
        if (!valid) {
          return this.$message.error(obj[Object.keys(obj)[0]][0].message);
        }
        //注册
        this.axios
          .post("/api/account/register/", {
            mobile: this.form.account,
            password: this.form.password,
            verify_code: this.form.verify_code,
            country: this.form.country,
            source: "pc",
          })
          .then(() => {
            this.$router.push({ path: "login" });
          });
      });
    },
    forgetPassword() {
      this.$refs["form"].validate((valid, obj) => {
        if (!valid) {
          return this.$message.error(obj[Object.keys(obj)[0]][0].message);
        }
        this.axios
          .post("/api/account/forget_password/", {
            mobile: this.form.account,
            password: this.form.password,
            verify_code: this.form.verify_code,
          })
          .then(() => {
            this.$router.push({ path: "login" });
          });
      });
    },
    getVerifyImage() {
      //获取图片验证码
      this.axios.get("/api/verify_code/image/").then((res) => {
        this.verifyImage = res.img;
        this.verifyKey = res.key;
      });
    },
    getVerifyCode() {
      //check 图形验证码 成功则继续 否则重新获取图形验证码
      this.axios
        .post("/api/verify_code/send/", {
          key: this.verifyKey,
          code: this.verifyCode,
          event: this.status,
          mobile: this.form.account,
        })
        .then(() => {
          this.countDown = 60;
          this.countDownTimeout();
        })
        .catch(() => {
          this.getVerifyImage();
        });
    },

    countDownTimeout() {
      this.countDownTimer = setTimeout(() => {
        if (this.countDown > 0) {
          this.countDown--;
          this.countDownTimeout();
        }
      }, 1000);
    },
    checkVerifyCodeEnter() {
      if (this.status == "login_tel") {
        this.doLogin();
      }
      if (this.status == "register") {
        this.doRegister();
      }
      if (this.status == "forget_password") {
        this.forgetPassword();
      }
    },
    goArticleByKey(key) {
      this.$router.push({ path: "/home/help", query: { key } });
    },
  },
};
</script>

<style scoped lang="scss">
.Login {
  width: 100%;
  height: 100vh;
  .loginMain {
    width: 100%;
    height: calc(100% - #{$topHeight});
    display: flex;
    align-items: center;
    position: relative;
    .bg {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      object-fit: cover;
    }
    .slogan {
      display: none;
      color: #fff;
      position: absolute;
      right: 55vw;
      top: 30vh;
      .mainTitle {
        font-size: 55px;
      }
      .subTitle {
        font-size: 40px;
        margin-top: 10px;
      }
    }
    .formContainer {
      background: #fff;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
      border-radius: 4px;
      width: 420px;
      padding: 40px;
      position: absolute;
      left: 60vw;
      box-sizing: border-box;
      .title {
        color: $darkColor;
        // font-weight: bold;
        font-size: 24px;
        margin-bottom: 20px;
        display: flex;
        align-items: baseline;
        .unSelected {
          color: $infoColor;
          font-size: 18px;
          cursor: pointer;
        }
      }
      // .el-input {
      //   width: 100%;
      //   margin: 12px 0;
      // }
      .el-button.submit_btn {
        margin-top: 12px;
        width: 100%;
      }
      .ul {
        font-size: 14px;
        display: flex;
        justify-content: flex-end;
        margin-top: 20px;
        user-select: none;
        margin-bottom: 20px;
        div {
          color: $themeColor;
          cursor: pointer;
          &:hover {
            text-decoration: underline;
          }
          &:after {
            content: "|";
            margin: 0 5px;
            color: #bfbfbf;
          }
          &:last-child:after {
            content: "";
            margin: 0;
          }
        }
      }
      .tip {
        font-size: 14px;
        text-align: center;
        color: $darkPlainColor;
        span {
          color: $warningColor;
          cursor: pointer;
        }
      }
    }
  }
}

/deep/.el-input__suffix {
  right: 0;
}
</style>
